import { useState } from 'react';
import { Link } from 'react-router-dom';
import AutumnalDecorations from './AutumnalDecorations';
import CountdownTimer from './CountdownTimer';
import AdminAccessModal from './AdminAccessModal';

export default function PreWeddingView() {
  const [showAdminModal, setShowAdminModal] = useState(false);

  return (
    <div className="min-h-screen relative flex flex-col">
      <AutumnalDecorations intensity="light" />
      
      {/* Main content */}
      <main className="flex-1 flex flex-col items-center justify-center px-4 py-12 relative z-10">
        {/* Hero section */}
        <div className="text-center mb-12 max-w-3xl">
          {/* Decorative element */}
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="w-16 h-px bg-gradient-to-r from-transparent via-autumn-gold to-transparent" />
            <svg className="w-8 h-8 text-autumn-gold" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C8 6 4 9 4 14c0 5 3.5 8 8 8s8-3 8-8c0-5-4-8-8-12z" />
            </svg>
            <div className="w-16 h-px bg-gradient-to-r from-transparent via-autumn-gold to-transparent" />
          </div>
          
          <p className="text-autumn-orange font-body text-lg tracking-widest uppercase mb-4">
            You are invited to celebrate
          </p>
          
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-display font-semibold text-autumn-brown mb-4">
            Nicola <span className="text-autumn-gold">&</span> Stuart
          </h1>
          
          <p className="text-xl md:text-2xl font-body text-autumn-light-brown italic">
            are getting married
          </p>
        </div>

        {/* Hero image */}
        <div className="w-full max-w-2xl mb-12">
          <div className="rounded-2xl shadow-xl overflow-hidden relative">
            <img 
              src="/nicolaandstuart.jpeg" 
              alt="Nicola & Stuart" 
              className="w-full h-auto object-cover"
            />
            {/* Decorative overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-autumn-cream/30 to-transparent pointer-events-none" />
          </div>
        </div>

        {/* Date display */}
        <div className="text-center mb-10">
          <p className="text-autumn-light-brown font-body text-lg tracking-wide mb-2">
            Saturday
          </p>
          <p className="text-3xl md:text-4xl font-display font-medium text-autumn-brown">
            October 3<sup>rd</sup>, 2026
          </p>
        </div>

        {/* Countdown */}
        <div className="w-full max-w-2xl">
          <CountdownTimer />
        </div>

        {/* RSVP buttons */}
        <div className="mt-10 flex flex-col sm:flex-row gap-4 items-center">
          <a
            href="https://forms.gle/fECWgE5DonUJrRgs8"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-autumn text-center"
          >
            RSVP &mdash; Day Guest
          </a>
          <a
            href="https://forms.gle/CZhyTtYzHCnMukFY9"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-autumn text-center"
          >
            RSVP &mdash; Evening Guest
          </a>
        </div>

        {/* Guest info link */}
        <div className="mt-6">
          <Link to="/info" className="btn-outline inline-flex items-center gap-2">
            Guest Information
          </Link>
        </div>

        {/* Message */}
        <p className="mt-8 text-autumn-light-brown font-body text-center max-w-md italic">
          We can't wait to celebrate with you. <br />
          Check back here to share photos on the day!
        </p>
      </main>

      {/* Footer with admin link */}
      <footer className="relative z-10 py-6 text-center">
        <button
          onClick={() => setShowAdminModal(true)}
          className="text-autumn-light-brown/40 hover:text-autumn-light-brown text-sm font-body transition-colors"
        >
          Admin
        </button>
      </footer>

      {/* Admin access modal */}
      {showAdminModal && (
        <AdminAccessModal onClose={() => setShowAdminModal(false)} />
      )}
    </div>
  );
}

